(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6130],{

/***/ 29182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/Alert/Alert.tsx + 1 modules
var Alert = __webpack_require__(60585);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Article/Article.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Articleelements__Wrapper",
  componentId: "sc-14t4bf-0"
})(["margin-top:", ";padding:0 ", ";@media (min-width:", "px){margin-top:", ";}"], (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf));
var Article_elements_Date = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Articleelements__Date",
  componentId: "sc-14t4bf-1"
})(["font-size:", ";@media (min-width:", "px){padding:0 ", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.textBase;
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(30));
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Articleelements__Title",
  componentId: "sc-14t4bf-2"
})(["font-weight:", ";font-size:", ";font-family:", ";margin:", " 0 ", " 0;@media (min-width:", "px){font-size:", ";padding:0 ", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h3;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h2;
}, (0,polished_esm/* rem */.hO)(30));
var ImageSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Articleelements__ImageSection",
  componentId: "sc-14t4bf-3"
})(["display:flex;justify-content:center;"]);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Articleelements__Image",
  componentId: "sc-14t4bf-4"
})(["border-radius:", ";max-width:100%;margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(12), (0,polished_esm/* rem */.hO)(30));
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Articleelements__Description",
  componentId: "sc-14t4bf-5"
})(["font-size:", ";line-height:", ";@media (min-width:", "px){padding:0 ", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(30));
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Article/Article.tsx







var ArticleTemplate = function ArticleTemplate(_ref) {
  var article = _ref.article;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Article_elements_Date, {
      children: moment_default()(article.publicationDate).format('D. M. YYYY')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: article.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImageSection, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/articles/").concat(article.photo)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
      dangerouslySetInnerHTML: {
        __html: article.text
      }
    })]
  });
};

/* harmony default export */ var Article_Article = (ArticleTemplate);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(94951);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/services/article.service.ts
var article_service = __webpack_require__(93003);
;// CONCATENATED MODULE: ./src/pages/clanok/[...slug].tsx

















var Article = function Article(props) {
  var _props$article;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  if (props !== null && props !== void 0 && props.status && (props === null || props === void 0 ? void 0 : props.status) !== 200) return /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
    type: Alert/* AlertTypes.error */.d.error
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.page.common'),
      description: props === null || props === void 0 ? void 0 : (_props$article = props.article) === null || _props$article === void 0 ? void 0 : _props$article.annotation,
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK,
      openGraph: {
        images: [{
          url: "https://profivzdelavanie.sk".concat((0,url_utils/* publicAssets */.VK)('/og-konferencia.png'))
        }]
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Article_Article, {
        article: props === null || props === void 0 ? void 0 : props.article
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

Article.getInitialProps = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(ctx) {
    var _yield$articleApi$det, data, _error$response;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return article_service/* articleApi.detail */.$.detail(ctx.query.slug);

          case 3:
            _yield$articleApi$det = _context.sent;
            data = _yield$articleApi$det.data;
            return _context.abrupt("return", {
              status: 200,
              article: data
            });

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);

            if (!((_context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 404)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", ctx.res.writeHead(302, {
              Location: constants/* ROUTES.NOT_FOUND */.Z6.NOT_FOUND
            }).end());

          case 12:
            return _context.abrupt("return", {
              status: 500
            });

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ var _slug_ = (Article);

/***/ }),

/***/ 93003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ articleApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var LIST = 'pv/article/list';
var LIST_CAROUSEL = 'pv/article/list-carousel';
var DETAIL = 'pv/article/slug';
var articleApi = {
  list: function list(limit, offset) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LIST, {
      limit: limit,
      offset: offset
    });
  },
  listCarousel: function listCarousel(limit, offset) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LIST_CAROUSEL, {
      limit: limit,
      offset: offset
    });
  },
  detail: function detail(slug) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug));
  }
};

/***/ }),

/***/ 31032:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clanok/[...slug]",
      function () {
        return __webpack_require__(29182);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,4623,9774,2888,179], function() { return __webpack_exec__(31032); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);